import { useState } from 'react'

const useRadio = () => {
  const [value, setValue] = useState()

  const handleChange = event => {
    event.persist()
    setValue(event.target.id)
  }

  return [value, handleChange]
}

export default useRadio
